export default "__VITE_ASSET__DGlV5tCt__"